import React from 'react';
import { inject } from 'mobx-react';

import { connectivityTypes } from '@kentik/ui-shared/dictionary/interfaceClassification';
import Link from 'core/components/Link';

const ConnectivityTypeLink = ({ $app, value, label, ...rest }) => {
  if (!value || !/[^-]/.test(value)) {
    return value || null;
  }

  const content = label || connectivityTypes[value] || value;

  if ($app.isSubtenant) {
    return content;
  }

  return (
    <Link to={`/v4/core/quick-views/connectivity-type/${value}`} {...rest}>
      {content}
    </Link>
  );
};

export default inject('$app')(ConnectivityTypeLink);
